import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from './features/landing/LandingPage';
import { LoginPage } from './features/auth/LoginPage';
import { RegisterPage } from './features/auth/RegisterPage';
import { DemoPage } from './features/auth/DemoPage';
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { VerifyEmailPage } from './features/auth/VerifyEmailPage';
import { ProtectedRoute } from './shared/auth/ProtectedRoute';
import { HomeRedirect } from './shared/auth/HomeRedirect';
import { CabinetLayout } from './shared/layout/CabinetLayout';
import { ProfilePage } from './features/client-cabinet/ProfilePage';
import { AddressBookPage } from './features/client-cabinet/AddressBookPage';
import { CargoTemplatesPage } from './features/client-cabinet/CargoTemplatesPage';
import { CounterpartiesPage } from './features/client-cabinet/CounterpartiesPage';
import { MyOrdersPage } from './features/client-cabinet/MyOrdersPage';
import { OrderFormPage } from './features/client-cabinet/OrderFormPage';
import { OrderDetailPage } from './features/client-cabinet/OrderDetailPage';
import { AllOrdersPage } from './features/manager/AllOrdersPage';
import { ContractsListPage } from './features/contracts/ContractsListPage';
import { ContractDetailPage } from './features/contracts/ContractDetailPage';
import { ShipmentsListPage } from './features/shipments/ShipmentsListPage';
import { ShipmentDetailPage } from './features/shipments/ShipmentDetailPage';
import { CarriersPage } from './features/manager/CarriersPage';
import { ExpeditionsPage } from './features/manager/ExpeditionsPage';
import { AllClientsPage } from './features/manager/AllClientsPage';
import { ClientDetailPage } from './features/manager/ClientDetailPage';
import { ExpeditorProfilePage } from './features/expeditor-profile/ExpeditorProfilePage';
import { StaffPage } from './features/admin-staff/StaffPage';
import { MailerSettingsPage } from './features/admin-mailer/MailerSettingsPage';
import { MailerLogPage } from './features/admin-mailer/MailerLogPage';
import { IntegrationsPage } from './features/admin-integrations/IntegrationsPage';
import { ServiceCatalogPage } from './features/admin-service-catalog/ServiceCatalogPage';
import { PoruchenieTemplatePage } from './features/admin-poruchenie/PoruchenieTemplatePage';
import { ReferenceDataPage } from './features/admin-reference/ReferenceDataPage';
import { ReferenceBookPage } from './features/admin-reference/ReferenceBookPage';
import { LinkBookPage } from './features/admin-reference/LinkBookPage';
import { ClassifierPage } from './features/admin-reference/ClassifierPage';
import { GuidePage } from './features/guides/GuidePage';
import { AuditSummaryPage } from './features/audit/AuditSummaryPage';
import {
  AuditAuthEventsPage,
  AuditCargoEventsPage,
  AuditClientsPage,
  AuditContractPartiesPage,
  AuditContractsPage,
  AuditDeregistrationsPage,
  AuditGeoTrackPage,
  AuditLogsPage,
  AuditOrdersPage,
  AuditPaymentsPage,
  AuditProfileChangesPage,
  AuditQuotesPage,
  AuditRegistrationEventsPage,
  AuditShipmentsPage,
} from './features/audit/AuditDetailPages';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />

        <Route element={<ProtectedRoute />}>
          {/* Кабинет клиента */}
          <Route path="/cabinet" element={<CabinetLayout />}>
            <Route index element={<HomeRedirect />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="addresses" element={<AddressBookPage />} />
            <Route path="cargo" element={<CargoTemplatesPage />} />
            <Route path="counterparties" element={<CounterpartiesPage />} />
            <Route path="orders" element={<MyOrdersPage />} />
            <Route path="orders/new" element={<OrderFormPage />} />
            <Route path="orders/:id" element={<OrderDetailPage source="client" />} />
            <Route path="orders/:id/edit" element={<OrderFormPage />} />
            <Route path="contracts" element={<ContractsListPage />} />
            <Route path="contracts/:id" element={<ContractDetailPage />} />
            <Route path="shipments" element={<ShipmentsListPage title="Мои перевозки" />} />
            <Route path="shipments/:id" element={<ShipmentDetailPage />} />
            <Route path="expeditor" element={<ExpeditorProfilePage />} />
            <Route path="guide" element={<GuidePage />} />
          </Route>

          {/* Кабинет менеджера/админа/аудитора */}
          <Route path="/manager" element={<CabinetLayout />}>
            <Route index element={<HomeRedirect />} />
            <Route path="orders" element={<AllOrdersPage />} />
            <Route path="orders/:id" element={<OrderDetailPage source="manager" />} />
            <Route path="orders/:id/edit" element={<OrderFormPage mode="manager" />} />
            <Route
              path="clients/:clientId/orders/new"
              element={<OrderFormPage mode="manager" />}
            />
            <Route path="contracts" element={<ContractsListPage />} />
            <Route path="contracts/:id" element={<ContractDetailPage />} />
            <Route path="shipments" element={<ShipmentsListPage title="Все перевозки" />} />
            <Route path="shipments/:id" element={<ShipmentDetailPage />} />
            <Route path="carriers" element={<CarriersPage />} />
            <Route path="expeditions" element={<ExpeditionsPage />} />
            <Route path="clients" element={<AllClientsPage />} />
            <Route path="clients/:id" element={<ClientDetailPage />} />
            {/* ДЕМО-СТЕНД: сотрудник заводит демо-клиента (эндпоинт сам проверяет DEMO_MODE). */}
            <Route path="demo-client" element={<RegisterPage mode="demo-client" />} />
            <Route path="expeditor" element={<ExpeditorProfilePage />} />
            <Route path="staff" element={<StaffPage />} />
            <Route path="mailer" element={<MailerSettingsPage />} />
            <Route path="mailer-log" element={<MailerLogPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="service-catalog" element={<ServiceCatalogPage />} />
            <Route path="poruchenie-template" element={<PoruchenieTemplatePage />} />
            <Route path="reference-data" element={<ReferenceDataPage />} />
            <Route path="reference-data/link" element={<LinkBookPage />} />
            <Route path="reference-data/classifier/:id" element={<ClassifierPage />} />
            <Route path="reference-data/:book" element={<ReferenceBookPage />} />
            <Route path="guide" element={<GuidePage />} />
          </Route>

          {/* Аудит / Проверка ПП 1317 — для ADMIN и AUDITOR */}
          <Route path="/audit" element={<CabinetLayout />}>
            <Route index element={<AuditSummaryPage />} />
            <Route path="clients" element={<AuditClientsPage />} />
            <Route path="registration-events" element={<AuditRegistrationEventsPage />} />
            <Route path="auth-events" element={<AuditAuthEventsPage />} />
            <Route path="profile-changes" element={<AuditProfileChangesPage />} />
            <Route path="deregistrations" element={<AuditDeregistrationsPage />} />
            <Route path="orders" element={<AuditOrdersPage />} />
            <Route path="quotes" element={<AuditQuotesPage />} />
            <Route path="contracts" element={<AuditContractsPage />} />
            <Route path="contract-parties" element={<AuditContractPartiesPage />} />
            <Route path="shipments" element={<AuditShipmentsPage />} />
            <Route path="cargo-events" element={<AuditCargoEventsPage />} />
            <Route path="geo-track" element={<AuditGeoTrackPage />} />
            <Route path="payments" element={<AuditPaymentsPage />} />
            <Route path="audit-logs" element={<AuditLogsPage />} />
          </Route>
        </Route>

        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}
